// Navigation only. The server still resolves the genuine current drawing.
const BOARD_LAST='/?view=last',BOARD_NEXT='/?view=next',PREVIOUS_PICKS='/previous-picks';
const boardView=value=>value==='next'?'next':'last';
function previousPicks(drawing){return PREVIOUS_PICKS+(/^\d{4}-\d{2}-\d{2}\|(midday|evening)$/.test(drawing||'')?'?drawing='+encodeURIComponent(drawing):'');}
module.exports={BOARD_LAST,BOARD_NEXT,PREVIOUS_PICKS,boardView,previousPicks};
